import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import DrawerView from '../DrawerView'

const CONNECTION_STATUSES = [
  {
    key: 'connected',
    title: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.connected.title',
    description: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.connected.description',
  },
  {
    key: 'notConnected',
    title: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.notConnected.title',
    description: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.notConnected.description',
  },
  {
    key: 'inviteSent',
    title: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.inviteSent.title',
    description: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.inviteSent.description',
  },
  {
    key: 'missingContact',
    title: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.missingContact.title',
    description: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.missingContact.description',
  },
]

const DrawerViewConnectionStatuses: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <DrawerView
      title={formatMessage({ id: 'resourceCollections.providers.connectOnlyFlow.connectionStatuses.title' })}
      showBackButton={false}
    >
      <Stack spacing={3} sx={{ p: 3 }}>
        {CONNECTION_STATUSES.map(status => (
          <Box key={status.key}>
            <Typography variant="subtitle1" gutterBottom>
              {formatMessage({ id: status.title })}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {formatMessage({ id: status.description })}
            </Typography>
          </Box>
        ))}
      </Stack>
    </DrawerView>
  )
}

export default DrawerViewConnectionStatuses
